import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import axiosMain from "../../../http/axios/axios_main";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { usePDF } from "react-to-pdf";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import {
  fetchRightsRequest,
  fetchUserRightsRequest,
} from "../../../store/actions";
import CustomToast from "../../../components/Toast";
import { saveAs } from "file-saver";

function PaymentStatus({ children }) {
  const tableRef = useRef(null);
  const dispatch = useDispatch();

  const [responseData, setResponseData] = useState(null);
  const FactoryModalClose = () => setFactoryCreate(false);
  const [FactoryCreate, setFactoryCreate] = useState(true);

  const { paymentId, auctionCenterId, userId } = useParams();
  localStorage.setItem("auctionCenterId", btoa(auctionCenterId));
  sessionStorage.setItem("argument2", btoa(userId));
  localStorage.setItem("argument2", btoa(userId));
  console.log("userid", atob(localStorage.getItem("argument2")));

  dispatch(fetchUserRightsRequest(auctionCenterId, userId));

  const fetchData = async () => {
    try {
      const { data } = await axiosMain.get(
        `/postauction/allocateFund/getPaymentDetailsAfterRedirect/${paymentId}/${auctionCenterId}`
      );
      setResponseData(data.responseData);

      // if (responseData?.baseUrl) {
      //   const url = `/auctionPage/${responseData.baseUrl}`;
      //   window.history.pushState({}, '', window.location.href);
      //   const url2 = window.location.href;//"https://teaboarduat.procuretiger.com/Tea/postauction/allocateFund/getPaymentDetailsAfterRedirect/MTAwMDQ=/88/1701";
      //   const parts = url2.split('/');
      // const baseUrl = `${parts[0]}//${parts[2]}/`+url;//"https://teaboarduat.procuretiger.com/auctionPage/MA==/dW5kZWZpbmVk/ODg=/MQ==";
      //   window.open( window.location.href, '_blank');
      //   window.location.reload();
      // } else {
      //   console.warn('No valid baseUrl found in response data');
      // }
    } catch (error) {
      console.error("Failed to fetch payment details:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const DownloadExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Prepare custom data (e.g., status message, amount, reference numbers, etc.)
    const customData = [
      [
        "Allocation of Funds has been " +
          getStatusMessage(responseData?.transStatus),
      ],
      ["Amount Rs. " + Number.parseFloat(responseData?.amount).toFixed(2)],
    ];

    if (responseData?.transStatus == 100) {
      customData.push(
        ["Request Ref No.", responseData?.paymentId],
        ["Bank Ref No.", responseData?.requestRefNo],
        [
          "Bank Transaction Date & Time",
          formatDate(responseData?.bankTransactionDateTime),
        ]
      );
    }

    // Add a blank row to separate the custom data from the table data
    customData.push([]);

    // Prepare headers for dealAndLotNosDtoList
    const headers = ["Sr. No.", "Deal Id No", "Lot No"];

    // Map dealAndLotNosDtoList data with index numbers
    const dealAndLotNosData =
      responseData?.dealAndLotNosDtoList?.map((item, index) => [
        index + 1, // Sr. No.
        item.dealIDNo,
        item.lotNo,
      ]) || [];

    // Combine custom data, blank row, headers, and dealAndLotNosDtoList data
    const sheetData = [
      ...customData, // custom data and an empty row
      headers, // headers for the table
      ...dealAndLotNosData, // table data
    ];

    // Convert the combined data into a sheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Append the single sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "PaymentStatus");

    // Write the workbook to a buffer and save as an Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "PaymentStatus.xlsx");
  };

  const DownloadPDF = () => {
    const doc = new jsPDF();
    const table = tableRef.current;
    //  console.log(tableRef.current);
    html2canvas(table).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      doc.save("PaymentStatus.pdf");
    });
  };

  // const DownloadExcel = () => {
  //   const data = responseData?.dealAndLotNosDtoList;
  //   if (data?.length > 0) {
  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.json_to_sheet(data);
  //     XLSX.utils.book_append_sheet(
  //       workbook,
  //       worksheet,
  //       "ViewAllocateFundBuyerData"
  //     );
  //     const excelBuffer = XLSX.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //     });
  //     const blob = new Blob([excelBuffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     saveAs(blob, "PaymentStatus.xlsx");
  //   } else {
  //     CustomToast.error("No Data Found");
  //   }
  // };

  const getStatusMessage = (status) => {
    switch (status) {
      case "100":
        return "Successful";
      case "101":
        return "Failed";
      case "102":
        return "Failure";
      case "103":
        return "Cancelled by user";
      case "106":
        return "Awaiting";
      case "108":
        return "Cancelled by System";
      case "110":
        return "Refunded";
      default:
        return "";
    }
  };

  const formatDate = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const pad = (num) => num.toString().padStart(2, "0");
    return `${pad(dateTime.getDate())}/${pad(
      dateTime.getMonth() + 1
    )}/${dateTime.getFullYear()} ${pad(dateTime.getHours())}:${pad(
      dateTime.getMinutes()
    )}:${pad(dateTime.getSeconds())}`;
  };
  return (
    <>
      <div id="pdfContent">
        <Modal
          show={FactoryCreate}
          onHide={FactoryModalClose}
          size="md"
          centered
          style={{ border: "1px solid #ccc" }}
        >
          <Modal.Header>
            <Modal.Title>Allocation of Funds Transaction Status</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => FactoryModalClose()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <div>
              <table className="table table-bordered" ref={tableRef}>
                <tr>
                  <td style={{ border: "none" }}>
                    <p style={{ padding: "10px 0" }}>
                      Allocation of Funds has been{" "}
                      {getStatusMessage(responseData?.transStatus)} for Amount
                      Rs. {Number.parseFloat(responseData?.amount).toFixed(2)}
                    </p>
                    {responseData?.transStatus == 100 && (
                      <div>
                        <p style={{ padding: "10px 0" }}>
                          Request Ref No.: {responseData?.paymentId}
                        </p>
                        <p style={{ padding: "10px 0" }}>
                          Bank Ref No.: {responseData?.requestRefNo}
                        </p>
                        <p style={{ padding: "10px 0" }}>
                          Bank Transaction Date & Time:{" "}
                          {formatDate(responseData?.bankTransactionDateTime)}
                        </p>
                      </div>
                    )}
                    <div className="table-container">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th style={{ padding: "10px 0" }}> Sr. No. </th>
                            <th style={{ padding: "10px 0" }}> Deal Id No </th>
                            <th style={{ padding: "10px 0" }}> Lot No </th>
                          </tr>
                        </thead>
                        <tbody>
                          {responseData?.dealAndLotNosDtoList?.map(
                            (item, index) => (
                              <tr key={index} style={{ padding: "10px 0" }}>
                                <td style={{ padding: "10px 0" }}>
                                  {index + 1}
                                </td>
                                <td style={{ padding: "10px 0" }}>
                                  {item.dealIDNo}
                                </td>
                                <td style={{ padding: "10px 0" }}>
                                  {item.lotNo}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>{" "}
                  </td>
                </tr>{" "}
              </table>
              <button
                onClick={DownloadPDF}
                className="SubmitBtn"
                style={{
                  padding: "10px",
                  marginLeft: "10px",
                  border: "none",
                }}
              >
                Export to PDF
              </button>{" "}
              <button
                onClick={DownloadExcel}
                className="SubmitBtn"
                style={{
                  padding: "10px",
                  marginLeft: "10px",
                  border: "none",
                }}
              >
                Export to Excel
              </button>{" "}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default PaymentStatus;
